<script lang="ts" setup>
import ContactForm from '~/components/forms/ContactForm.vue'

const title = 'Contacto'
useHead({ title })

const contact = ref<components['schemas']['Contact']>()
const { company } = useCompany()

const onComplete = (instance: components['schemas']['Contact']) => {
  contact.value = instance
}
</script>

<template>
  <div class="mx-0 px-4 lg:mx-20">
    <PageHeader>
      <PageTitle>{{ title }}</PageTitle>
    </PageHeader>

    <div class="flex gap-5">
      <div class="w-1/3">
        <div v-if="company">
          <img
            v-if="company.logo"
            :src="company.logo"
            class="object-contain w-3/4"
          />
          <div class="space-y-2 text-lg">
            <NuxtLink
              :to="`https://wa.me/${company.phone_number}`"
              class="block"
              external
              target="_blank"
            >
              <i class="pi pi-phone" />
              {{ formatPhoneNumber(company.phone_number) }}
            </NuxtLink>
            <NuxtLink
              :to="`mailto:${company.email}`"
              class="block"
              external
              target="_blank"
            >
              <i class="pi pi-envelope" /> {{ company.email }}
            </NuxtLink>
            <div><i class="pi pi-clock" /> Lunes a Sábado: 9am - 6pm</div>
          </div>
        </div>
      </div>
      <div class="flex-grow">
        <Message v-if="contact" class="mb-5" icon="pi pi-check" severity="info">
          Tu mensaje ha sido enviado satisfactoriamente.<br />
          Recibirás una respuesta tan pronto sea posible a través de
          {{ ContactStrategyName[contact.strategy] }}.<br />
          Protege tus códigos de compra y así asegurar tu ingreso al evento.<br />
        </Message>

        <ContactForm v-else @complete="onComplete" />
      </div>
    </div>
  </div>
</template>
